import { inject } from "vue";
import { checkoutStoreKeys } from "./useCheckout";

export function useCheckoutStore() {
  const checkout = inject(checkoutStoreKeys);

  if (!checkout) {
    throw new Error("useCheckoutStore must be used within a CheckoutProvider");
  }

  return checkout
}